import { useState } from "react";

export function usePlanDialogWrapperHooks() {
    const [showDialog, setShowDialog] = useState(false);

    return { showDialog, setShowDialog };
}
